var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "training-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZH.Screen.Web.Services-Coding",
    transform: "translate(-1100, -3274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "training-icon",
    transform: "translate(1110, 3284)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    fill: "#348389",
    cx: 60,
    cy: 60,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "meeting-board-svgrepo-com-2",
    transform: "translate(35, 35)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,19.9942034 L17.5,19.9942034 C18.8807119,19.9942034 20,18.8752396 20,17.4949279 C20,16.1146162 18.8807119,14.9956525 17.5,14.9956525 L12.5,14.9956525 C11.1192881,14.9956525 10,16.1146162 10,17.4949279 C10,18.8752396 11.1192881,19.9942034 12.5,19.9942034 Z M47.5,4.99855084 L27.5,4.99855084 L27.5,2.49927542 C27.5,1.11896372 26.3807119,0 25,0 C23.6192881,0 22.5,1.11896372 22.5,2.49927542 L22.5,4.99855084 L2.5,4.99855084 C1.11928813,4.99855084 0,6.11751456 0,7.49782626 L0,32.4905805 C0,36.6315156 3.35786438,39.9884067 7.5,39.9884067 L18.975,39.9884067 L13.225,45.7117474 C12.7517184,46.1810279 12.4855042,46.8198323 12.4855042,47.486233 C12.4855042,48.1526336 12.7517184,48.7914381 13.225,49.2607185 C13.6944165,49.733863 14.3334062,50 15,50 C15.6665938,50 16.3055835,49.733863 16.775,49.2607185 L22.5,43.5123851 L22.5,47.486233 C22.5,48.8665447 23.6192881,49.9855084 25,49.9855084 C26.3807119,49.9855084 27.5,48.8665447 27.5,47.486233 L27.5,43.5123851 L33.225,49.2607185 C33.6944165,49.733863 34.3334062,50 35,50 C35.6665938,50 36.3055835,49.733863 36.775,49.2607185 C37.2482816,48.7914381 37.5144958,48.1526336 37.5144958,47.486233 C37.5144958,46.8198323 37.2482816,46.1810279 36.775,45.7117474 L31.025,39.9884067 L42.5,39.9884067 C46.6421356,39.9884067 50,36.6315156 50,32.4905805 L50,7.49782626 C50,6.11751456 48.8807119,4.99855084 47.5,4.99855084 Z M45,32.4905805 C45,33.8708922 43.8807119,34.9898559 42.5,34.9898559 L7.5,34.9898559 C6.11928813,34.9898559 5,33.8708922 5,32.4905805 L5,9.99710168 L45,9.99710168 L45,32.4905805 Z M12.5,29.991305 L27.5,29.991305 C28.8807119,29.991305 30,28.8723413 30,27.4920296 C30,26.1117179 28.8807119,24.9927542 27.5,24.9927542 L12.5,24.9927542 C11.1192881,24.9927542 10,26.1117179 10,27.4920296 C10,28.8723413 11.1192881,29.991305 12.5,29.991305 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training-icon.f01da501fb7085202690a26c5f57ed85.svg";
export { ForwardRef as ReactComponent };